import { PageController } from '@client/components/_core/layout/PageController';
import { PublicNoIndex } from '@client/components/_shared/public/PublicNoIndex';
import { Loading } from '@client/components/_ui/feedback/Loading';
import { InvoicePrintView } from '@client/components/financials/invoices/InvoicePrintView';
import { trpcOptions } from '@client/trpc/client';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

export const Route = createFileRoute('/public/$orgId/invoice/view/$accessKey')({ component: ViewInvoice });

function ViewInvoice(): JSX.Element {
    const { orgId, accessKey } = Route.useParams();

    const { data: invoice, isLoading } = useQuery(
        trpcOptions.invoice.getInsurerInvoiceByAccesskey.queryOptions(
            {
                accessKey,
                orgId: orgId,
            },
            // Server-side this is `publicProcedureWithCaptcha`. Without a minted credential the
            // request is rejected outright in every environment where captcha is enforced.
            { trpc: { context: { captcha: true, captchaSingleUse: true } } },
        ),
    );

    return (
        <PageController route={Route}>
            <PublicNoIndex />
            {isLoading || !invoice ? <Loading /> : <InvoicePrintView invoiceData={invoice} open={true} />}
        </PageController>
    );
}
